import { displayStringFromFHIRQuantity } from "../../datatypeComponents/QuantityEntry";
import { displayStringFromFHIRRange } from "../../datatypeComponents/RangeEntry";

const createEvidenceDisplay = (item) => {
    let description = item.description;
    let statistics = item.statistic?.map(statistic => {
        let statisticDisplay = "";
        if (statistic.category) {
            let categoryDisplay = statistic.category.text || statistic.category.coding?.[0]?.display;
            statisticDisplay = "for " + categoryDisplay + ", "
        }
        if (statistic.numberAffected || statistic.numberAffected === 0) {
            statisticDisplay += statistic.numberAffected + " ";
        }
        if (statistic.sampleSize?.numberAnalyzed || statistic.sampleSize?.numberAnalyzed === 0) {
            statisticDisplay += "out of " + statistic.sampleSize.numberAnalyzed + ": ";
        } else if (statistic.sampleSize?.knownDataCount || statistic.sampleSize?.knownDataCount === 0) {
            statisticDisplay += "out of " + statistic.sampleSize.knownDataCount + ": ";
        } else if (statistic.sampleSize?.numberOfParticipants ||
            statistic.sampleSize?.numberOfParticipants === 0) {
            statisticDisplay += "out of " + statistic.sampleSize.numberOfParticipants + ": ";
        }
        if (statistic.description) {
            statisticDisplay += statistic.description;
        } else {
            let statisticType = statistic.statisticType?.coding?.[0]?.display ||
                statistic.statisticType?.text || "";
            let statisticQuantity = displayStringFromFHIRQuantity(statistic.quantity) || "";
            statisticDisplay += statisticType + " " + statisticQuantity;
            if (statistic.attributeEstimate?.length) {
                let attributeEstimatesDisplay = statistic.attributeEstimate.map(estimate => {
                    let estimateDisplay = estimate.description || "";
                    if (!estimateDisplay) {
                        let estimateType = estimate.type?.coding?.[0]?.display || estimate.type?.text || "";
                        let estimateQuantity = displayStringFromFHIRQuantity(estimate.quantity) || "";
                        let estimateRange = displayStringFromFHIRRange(estimate.range) || "";
                        if (estimate.level) {
                            estimateDisplay = (100 * estimate.level).toString() + "% ";
                        }
                        estimateDisplay += estimateType + " " + estimateQuantity + estimateRange;
                    }
                    if (estimate.note?.length) {
                        for (let note of estimate.note) {
                            if (note.text) {
                                estimateDisplay += "; " + note.text;
                            }
                        }
                    }
                    return estimateDisplay;
                }).join(", ");
                statisticDisplay += " (" + attributeEstimatesDisplay + ")";
            }
        }
        if (statistic.note?.length) {
            for (let note of statistic.note) {
                if (note.text) {
                    statisticDisplay += "; " + note.text;
                }
            }
        }
        return statisticDisplay;
    }).join("; ");
    let notes = item.note?.map(note => note.text).join("; ");
    let evidenceDisplay = "";
    if (statistics) {
        evidenceDisplay = statistics;
    } else if (description) {
        evidenceDisplay = description;
    }
    if (notes) {
        if (evidenceDisplay) {
            evidenceDisplay += "; ";
        }
        evidenceDisplay += notes;
    }
    return evidenceDisplay;
};

const createSimpleEvidenceDisplay = (item) => {

    let statistics = item?.statistic?.map(statistic => {
        let statisticDisplay = "";
        if (statistic.category) {
            let categoryDisplay = statistic.category.text || statistic.category.coding?.[0]?.display;
            statisticDisplay = "for " + categoryDisplay + ", "
        }
        if (statistic.description) {
            statisticDisplay += statistic.description;
        } else {
            let statisticType = statistic.statisticType?.coding?.[0]?.display ||
                statistic.statisticType?.text || "";
            let statisticQuantity = displayStringFromFHIRQuantity(statistic.quantity) || "";
            statisticDisplay += statisticType + " " + statisticQuantity;
            if (statistic.attributeEstimate?.length) {
                let attributeEstimatesDisplay = statistic.attributeEstimate.map(estimate => {
                    let estimateDisplay = estimate.description || "";
                    if (!estimateDisplay && (!isNaN(estimate.quantity?.value) ||
                        !isNaN(estimate.range?.low?.value) || !isNaN(estimate.range?.high?.value))) {
                        let estimateType = estimate.type?.coding?.[0]?.display || estimate.type?.text || "";
                        let estimateQuantity = displayStringFromFHIRQuantity(estimate.quantity) || "";
                        let estimateRange = displayStringFromFHIRRange(estimate.range) || "";
                        if (estimate.level) {
                            estimateDisplay = (100 * estimate.level).toString() + "% ";
                        }
                        estimateDisplay += estimateType + " " + estimateQuantity + estimateRange;
                    }
                    if (estimate.note?.length) {
                        for (let note of estimate.note) {
                            if (note.text) {
                                estimateDisplay += "; " + note.text;
                            }
                        }
                    }
                    return estimateDisplay;
                }).join(", ");
                statisticDisplay += " (" + attributeEstimatesDisplay + ")";
            }
        }
        return statisticDisplay;
    }).join("; ");

    return statistics || "";
};

export default createEvidenceDisplay;
export { createSimpleEvidenceDisplay };